<template>
<div class="welcome">
	You are now connected to the Internet...
</div>
</template>

<script>

import mappings from "@/mappings/index";

export default {
  name: "Welcome"
}

</script>

<style scoped>

</style>